export const getters = {
  isAuthenticated: state => !!state.accessToken,
  hasUser: state => !!state.user,
  getUserGuid: state => !!state.user && state.user.guid
}
